import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'
import { mediaQuery, mediaQueryDown } from '../../../utils/mediaQuery'
import { ISearchStylesProps } from '../AutoSuggest/AutoSuggest'

const mobileUpBreakpoint = ClinTheme.breakpoints[0]
const tabletUpBreakpoint = ClinTheme.breakpoints[1]

export const StyledGlobalSearchforAUS = styled.section({
  position: 'relative',
  width: '100%',
  maxWidth: '1140px',
  margin: 'auto',
  paddingLeft: '20px',
  paddingRight: '20px',
  boxSizing: 'border-box',
  [mediaQueryDown(mobileUpBreakpoint)]: {
    paddingLeft: '10px',
    paddingRight: '10px'
  }
})

export const StyledSearchWrapperForAUS = styled.div<ISearchStylesProps>({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  top: '-40px',
  borderRadius: '60px',
  height: '65px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.16), 0px 0px 8px rgba(0, 0, 0, 0.16)',
  padding: `${ClinTheme.space[0]}px ${ClinTheme.space[4]}`,
  [`.clin-icon`]: {
    transition: '.2s linear color',
    color: ClinTheme.colors.white,
    left: ClinTheme.space[4]
  },
  [`> input:focus`]: {
    [`~ .clin-icon`]: {
      color: ClinTheme.colors.primary
    },
    borderColor: ClinTheme.colors.primaryLighter
  },
  [mediaQuery(tabletUpBreakpoint)]: {
    maxWidth: 1068,
    maxHeight: 68,
    margin: 'auto'
  },
  [mediaQueryDown(mobileUpBreakpoint)]: {
    top: '-20px',
    height: '55px',
    padding: `${ClinTheme.space[0]}px ${ClinTheme.space[3]}`,
    [`span`]: {
      display: 'inline'
    },
    [`.clin-icon`]: {
      height: '24px',
      left: '14px'
    }
  }
})

export const StyledSearchInputAus = styled.input<ISearchStylesProps>({
  fontFamily: ClinTheme.fonts.body,
  position: 'relative',
  flex: '1 1 auto',
  marginBottom: '0',
  textIndent: ClinTheme.space[6],
  paddingBottom: ClinTheme.space[0],
  paddingTop: ClinTheme.space[0],
  paddingLeft: ClinTheme.space[4],
  paddingRight: ClinTheme.space[4],
  fontSize: ClinTheme.fontSizes[2],
  fontWeight: ClinTheme.fontWeights.normal,
  color: ClinTheme.colors.black,
  borderRadius: ClinTheme.space[5],
  border: `5px solid ${ClinTheme.colors.primaryLight}`,
  textOverflow: 'ellipsis',
  transition: '.2s linear background-color, .2s linear color',
  '::placeholder': {
    color: 'inherit'
  },
  ':-ms-input-placeholder': {
    height: '40px'
  },
  [`:placeholder-shown`]: {
    color: ClinTheme.colors.darkGrey
  },
  [`:focus`]: {
    outline: ClinTheme.space[0]
  },
  [mediaQuery(tabletUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[3]
  },
  [mediaQueryDown(mobileUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[2],
    textIndent: ClinTheme.space[5],
    paddingLeft: ClinTheme.space[3],
    paddingRight: ClinTheme.space[3]
  }
})

export const StyledResultsAus = styled.ul<ISearchStylesProps>(
  {
    listStyle: 'none',
    position: 'absolute',
    top: '26px',
    margin: '16px 0 0 0',
    padding: '0',
    width: '96%',
    maxWidth: '1140px',
    backgroundColor: ClinTheme.colors.lightGrey,
    boxShadow: '0px 1px 13px -6px rgba(0,0,0,0.75)',
    zIndex: 1300,
    borderRadius: ClinTheme.radii[3]
  },
  ({ showSuggestions }) => ({
    display: showSuggestions ? 'block' : 'none'
  })
)
